import React from 'react';

/**
 * Mass Master Pro Logo Component
 * White hard hat with scale/balance icon
 * Used consistently throughout the application
 */
const MassMasterLogo = ({ className = "w-10 h-10", showText = false, variant = "default" }) => {
  // Determine colors based on variant
  const isDark = variant === "dark";
  const hatColor = isDark ? "#1E3A5F" : "#FFFFFF";
  const hatStroke = isDark ? "#0F172A" : "#E5E7EB";
  const scaleColor = isDark ? "#FFC107" : "#3B82F6";
  const bgColor = isDark ? "#F1F5F9" : "#1E40AF";

  return (
    <div className={`flex items-center gap-2 ${showText ? '' : ''}`}>
      <svg 
        viewBox="0 0 100 100" 
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background Circle */}
        <circle cx="50" cy="50" r="48" fill={bgColor} />
        
        {/* Hard Hat - Main Dome (White) */}
        <path 
          d="M18 52 C18 30 32 18 50 18 C68 18 82 30 82 52 L82 58 L18 58 Z" 
          fill={hatColor}
          stroke={hatStroke}
          strokeWidth="2"
        />
        
        {/* Hard Hat - Brim */}
        <rect x="12" y="54" width="76" height="10" rx="4" fill={hatColor} stroke={hatStroke} strokeWidth="2" />
        
        {/* Hard Hat - Center Ridge */}
        <path 
          d="M50 18 L50 52" 
          stroke={hatStroke}
          strokeWidth="1.5"
          strokeDasharray="4 2"
        />
        
        {/* Scale/Balance Icon on Hat */}
        {/* Center Pole */}
        <line x1="50" y1="28" x2="50" y2="48" stroke={scaleColor} strokeWidth="3" strokeLinecap="round" />
        
        {/* Top Triangle */}
        <polygon points="50,26 46,32 54,32" fill={scaleColor} />
        
        {/* Balance Beam */}
        <line x1="32" y1="36" x2="68" y2="36" stroke={scaleColor} strokeWidth="3" strokeLinecap="round" />
        
        {/* Left Pan Strings */}
        <line x1="32" y1="36" x2="28" y2="44" stroke={scaleColor} strokeWidth="2" />
        <line x1="32" y1="36" x2="36" y2="44" stroke={scaleColor} strokeWidth="2" />
        
        {/* Right Pan Strings */}
        <line x1="68" y1="36" x2="64" y2="44" stroke={scaleColor} strokeWidth="2" />
        <line x1="68" y1="36" x2="72" y2="44" stroke={scaleColor} strokeWidth="2" />
        
        {/* Left Pan (curved) */}
        <path d="M24 44 Q32 50 40 44" stroke={scaleColor} strokeWidth="2.5" fill="none" strokeLinecap="round" />
        
        {/* Right Pan (curved) */}
        <path d="M60 44 Q68 50 76 44" stroke={scaleColor} strokeWidth="2.5" fill="none" strokeLinecap="round" />
        
        {/* Base Stand */}
        <rect x="44" y="48" width="12" height="4" rx="1" fill={scaleColor} />
      </svg>
      
      {showText && (
        <div className="flex flex-col">
          <span className={`text-lg font-bold leading-tight ${isDark ? 'text-slate-900' : 'text-white'}`}>
            Mass Master
          </span>
          <span className={`text-xs font-semibold tracking-wider ${isDark ? 'text-blue-600' : 'text-blue-300'}`}>
            PRO
          </span>
        </div>
      )}
    </div>
  );
};

export default MassMasterLogo;
